<template>
  <div class="page-container">
    <div class="my">
      <!-- 头部背景 -->
      <div class="home-wrapper"></div>
      
      <!-- 视角切换器 -->
      <div class="perspective-switcher" v-if="showPerspectiveSwitcher">
        <div class="switcher-container">
          <div 
            class="switcher-item" 
            :class="{ active: currentPerspective === 'buyer' }"
            @click="switchPerspective('buyer')"
          >
            <img src="@/assets/img/my/people.png" class="switcher-icon" />
            <span>个人中心</span>
          </div>
          <div 
            class="switcher-item" 
            :class="{ active: currentPerspective === 'seller' }"
            @click="switchPerspective('seller')"
          >
            <img src="@/assets/img/my/merchants.png" class="switcher-icon" />
            <span>店铺管理</span>
          </div>
        </div>
      </div>

      <!-- 店铺选择器 (仅在店铺管理视角显示) -->
      <div class="store-selector" v-if="currentPerspective === 'seller' && managedStores.length > 0">
        <div class="store-selector-container" @click="showStoreList = true">
          <div class="current-store">
            <img :src="currentStore.logo || '@/assets/img/my/user-logo.png'" class="store-logo" />
            <div class="store-info">
              <div class="store-name">{{ currentStore.storeName || '暂无' }}</div>
              <div class="store-role">{{ getCurrentStoreRole() }}</div>
            </div>
            <i class="arrow-down">▼</i>
          </div>
        </div>
      </div>

      <!-- 店铺列表弹窗 -->
      <div class="store-list-modal" v-if="showStoreList" @click="showStoreList = false">
        <div class="store-list-content" @click.stop>
          <div class="modal-header">
            <h3>选择店铺</h3>
            <span class="close-btn" @click="showStoreList = false">&times;</span>
          </div>
          <!-- 搜索框 -->
          <div class="store-search">
            <input
              v-model="storeSearchKeyword"
              type="text"
              placeholder="输入店铺名称过滤..."
              class="store-search-input"
            />
          </div>
          <div class="store-list">
            <div 
              class="store-item" 
              v-for="storeUser in filteredManagedStores" 
              :key="storeUser.storeId"
              :class="{ active: storeUser.storeId === currentStoreId }"
              @click="switchStore(storeUser)"
            >
              <img :src="storeUser.store.logo || '@/assets/img/my/user-logo.png'" class="store-logo" />
              <div class="store-info">
                <div class="store-name">{{ storeUser.store.storeName }}</div>
                <div class="store-role">{{ getStoreRole(storeUser) }}</div>
              </div>
              <img v-if="storeUser.storeId === currentStoreId" src="@/assets/img/my/user-logo.png" class="check-icon" />
            </div>
          </div>
        </div>
      </div>
      
      <div class="user-msg" v-if="currentPerspective === 'buyer'">
        <div class="left" @click="jumpUser">
          <img :src="getUserAvatar()" class="user-img"/>
          <div class="user-content">
            <div class="user-name">
              {{ getUserDisplayName() }}
            </div>
            <div class="user-reputation">
              <i>身份:</i>
              <i class="level">{{ getUserRoleText() }}</i>
            </div>
          </div>
        </div>

        <div class="logout-btn" @click="logout" v-if="currentPerspective === 'buyer'">
          <img src="@/assets/img/my/close.png" class="logout-icon" alt/>
          退出
        </div>
      </div>

      <div class="content-box">
        <div class="user-body">
          <div class="box" v-for="(menuGroup, groupIndex) in currentMenuGroups" :key="groupIndex">
            <p class="box-content"
              v-for="(item, index) in menuGroup"
              :key="index"
              @click="handleMenuClick(item)">
              <img :src="item.icon" :alt="item.text" class="box-img" :style="item.iconStyle || {}"/>
              <i class="box-text">{{item.text}}</i>
            </p>
          </div>
        </div>
      </div>
      
      <!-- 卖家视角底部功能 -->
      <div class="user-foot" v-if="currentPerspective === 'seller'">
        <div class="content" @click="jumpExhibition">
          <img src="@/assets/img/my/Exhibition.png" alt class="content-img"/>
          <i class="content-text">商品管理</i>
        </div>
        <div class="content" @click="jumpShelfManager">
          <img src="@/assets/img/my/merchants.png" alt class="content-img"/>
          <i class="content-text">分类管理</i>
        </div>
        <div class="content" @click="jumpScan">
          <img src="@/assets/img/my/scan.png" alt class="content-img"/>
          <i class="content-text">扫一扫</i>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'
  import {aGet, aPost} from '../../utils/request'
  import $ from 'jquery'
  import {NavBar} from 'vant'
  import {mapActions} from 'vuex'
  import nfc from '../../utils/nfc.js'
  import storeUserApi from '@/api/v3/storeUser';
  import userApi from '../../api/v3/user'
  import { clearSession } from '../../utils/session'
  
  export default {
    name: 'my',
    components: {},
    data() {
      return {
        // 基础数据
        userId: localStorage.getItem('userId') || 0,
        storeId: parseInt(localStorage.getItem('storeId')) || 0,
        currentStoreId: parseInt(localStorage.getItem('storeId')) || 0,
        
        // 用户和店铺信息
        userProfile: {}, // V3版本的用户个人信息
        userinfo: {}, // 旧版用户信息（兼容用）
        store: {}, // 当前店铺信息
        storeUsers: [], // 用户关联的店铺列表
        managedStores: [], // 有管理权限的店铺列表
        currentStore: {}, // 当前选中的店铺信息
        
        // UI状态
        currentPerspective: localStorage.getItem('currentPerspective') || 'buyer', // 当前视角
        showPerspectiveSwitcher: false, // 是否显示视角切换器
        showStoreList: false, // 是否显示店铺列表
        storeSearchKeyword: '', // 店铺过滤关键字
        
        // 权限相关
        permissionsList: [],
        powerStatus: undefined,
        
        // 其他
        scan: null,
        codeUrl: '',
        
        // 买家视角菜单 - 单一数组，每4个自动分行
        buyerMenuItems: [
          {
            text: '基本信息',
            icon: require('@/assets/img/my/edit.png'),
            path: '/accountInfo'
          },
          {
            text: '我的订单',
            icon: require('@/assets/img/my/Notepad.png'),
            path: '/imprint'
          },
          // {
          //   text: '购物车',
          //   icon: require('@/assets/img/my/service.png'),
          //   path: '/cart'
          // },
          {
            text: '我的关注',
            icon: require('@/assets/img/my/people.png'),
            path: '/FocusOn'
          },
          {
            text: '我的帮币',
            icon: require('@/assets/img/my/service.png'),
            path: '/profile/my-wallet'
          },
          {
            text: '我的推广',
            icon: require('@/assets/img/my/people.png'),
            path: '/agent/order',
            showIfAgent: true
          },
          {
            text: '超级管理',
            icon: require('@/assets/img/my/merchants.png'),
            path: '/profile/super-admin',
            showIfSuperAdmin: true
          },
          {
            text: '记事本',
            icon: require('@/assets/img/my/Notepad.png'),
            path: '/Notepad'
          },
          {
            text: '地址管理',
            icon: require('@/assets/img/my/address.png'),
            path: '/Residence'
          },
          {
            text: '协议',
            icon: require('@/assets/img/my/agreement.png'),
            path: '/agreement'
          },
        ],
        
        // 卖家视角菜单 - 单一数组，每4个自动分行
        sellerMenuItems: [
          {
            text: '加盟店管理',
            icon: require('@/assets/img/my/Notepad.png'),
            path: '/profile/sub-store',
            isHeadStoreOnly: true
          },
          {
            text: '店铺设置',
            icon: require('@/assets/img/my/card.png'),
            path: '/profile/store/info'
          },
          {
            text: '资源管理',
            icon: require('@/assets/img/imprint/shop.png'),
            path: '/resource/manager'
          },
          {
            text: '用户管理',
            icon: require('@/assets/img/my/people.png'),
            path: '/profile/store-user',
            beforeNavigate: function() {
              this.updateCurrentStoreId();
            }
          },
          {
            text: '展台群',
            icon: require('@/assets/img/my/people.png'),
            path: '/Group',
            needPermission: '展台群'
          },


          {
            text: '上传离线包',
            icon: require('@/assets/img/my/downloads.png'),
            path: '/upproducts',
            iconStyle: {
              transform: 'rotate(180deg)'
            }
          },
          {
            text: '下载离线包',
            icon: require('@/assets/img/my/downloads.png'),
            path: '/downproducts'
          },

          // {
          //   text: '已购服务',
          //   icon: require('@/assets/img/my/service.png'),
          //   path: '/purchased'
          // },
          // {
          //   text: '公告管理',
          //   icon: require('@/assets/img/my/agreement.png'),
          //   path: '/Announcement',
          //   query: function() {
          //     return { storeId: this.storeId };
          //   }
          // },

          // {
          //   text: '记事本',
          //   icon: require('@/assets/img/my/Notepad.png'),
          //   path: '/Notepad',
          //   needPermission: '记事本'
          // },
          {
            text: '撞宝',
            icon: require('@/assets/img/detail/lottery_icons.png'),
            path: '/Lottery',
            query: function() {
              return { storeId: this.storeId };
            }
          },
          {
            text: '客服',
            icon: require('@/assets/img/my/customer.png'),
            path: '/customer'
          },
          {
            text: '缴费寄存',
            icon: require('@/assets/img/my/agreement.png'),
            path: '/addressbook'
          },
          {
            text: '链接管理',
            icon: require('@/assets/img/my/Notepad.png'),
            path: '/store/external-link'
          },
          {
            text: '广告',
            icon: require('@/assets/img/my/ad.png'),
            path: '/Advertisement',
            needPermission: '广告'
          },

          {
            text: '美工',
            icon: require('@/assets/img/my/ui.png'),
            path: '/artist',
            needPermission: '美工'
          }
        ]
      }
    },
    
    computed: {
      // 根据当前视角返回对应的菜单组
      currentMenuGroups() {
        const self = this;
        let filteredItems;
        
        if (this.currentPerspective === 'buyer') {
          // 过滤买家菜单项
          filteredItems = this.buyerMenuItems.filter(function(item) {
            // 如果需要代理权限但用户没有代理身份，则隐藏
            if (item.showIfAgent && !self.hasAgentRole) {
              return false;
            }
            // 如果需要超级管理员权限但用户不是超级管理员，则隐藏
            if (item.showIfSuperAdmin && (!self.userProfile.isSuperAdmin || self.userProfile.isSuperAdmin !== 1)) {
              return false;
            }
            return true;
          });
        } else {
          // 过滤卖家菜单项
          filteredItems = this.sellerMenuItems.filter(function(item) {
            return !item.isHeadStoreOnly || self.store.isHeadStore === 1;
          });
        }
        
        // 将过滤后的菜单项按每4个分组
        const groups = [];
        for (let i = 0; i < filteredItems.length; i += 4) {
          groups.push(filteredItems.slice(i, i + 4));
        }
        return groups;
      },
      
      // 检查是否有代理身份
      hasAgentRole() {
        return this.storeUsers.some(function(store) {
          return store.isAgent === 1;
        });
      },
      
      // 检查是否有管理员身份
      hasAdminRole() {
        return this.storeUsers.some(function(store) {
          return store.isAdmin === 1;
        });
      },

      // 检查是否为超级管理员
      isSuperAdmin() {
        return this.userProfile && this.userProfile.isSuperAdmin === 1;
      }
      ,
      // 过滤后的可管理店铺列表
      filteredManagedStores() {
        const keyword = (this.storeSearchKeyword || '').trim().toLowerCase();
        if (!keyword) return this.managedStores;
        return this.managedStores.filter(function(storeUser) {
          const name = (storeUser && storeUser.store && storeUser.store.storeName) ? storeUser.store.storeName.toLowerCase() : '';
          return name.indexOf(keyword) !== -1;
        });
      }
    },
    
    methods: {
      // =============================================================================
      // 数据初始化相关方法
      // =============================================================================
      
      // 初始化所有数据（按顺序执行）
      async initializeData() {
        try {
          // 1. 并行获取用户信息和店铺关系列表
          await Promise.all([
            this.loadUserProfile(),
            this.loadStoreUsers()
            //this.loadUserInfo()
          ]);
          
          // 2. 根据用户信息和店铺关系初始化视角和权限
          this.initializePerspective();
          
          console.log('数据初始化完成');
        } catch (error) {
          console.error('数据初始化失败：', error);
          this.$toast('页面初始化失败，请重新登录');
        }
      },
      
      // 获取用户店铺关系列表
      async loadStoreUsers() {
        try {
          this.storeUsers = await storeUserApi.getMyStores();
          console.log('用户店铺列表：', this.storeUsers);
        } catch (error) {
          console.error('获取用户店铺列表失败：', error);
          throw error;
        }
      },
      
      // 获取用户个人信息（V3版本）
      async loadUserProfile() {
        try {
          this.userProfile = await userApi.getUserProfile();
          console.log('用户个人信息：', JSON.stringify(this.userProfile));
        } catch (error) {
          console.error('获取用户个人信息失败：', error);
        }
      },
      
      // 获取用户信息（旧版本，兼容用）
      async loadUserInfo() {
        try {
          const params = { id: this.userId };
          const response = await aPost(api.getUserInfo, params);
          
          if (!response || !response.data || response.data.code !== 0 || !response.data.data) {
            throw new Error('获取用户信息失败');
          }
          
          const userData = response.data.data;
          this.userinfo = userData;
          
          // 更新当前店铺信息（如果在卖家视角且有店铺数据）
          if (this.currentPerspective === 'seller' && userData.store) {
            this.updateStoreInfo(userData.store);
          }
          
          console.log('用户信息：', this.userinfo);
        } catch (error) {
          console.error('获取用户信息失败：', error);
          this.$toast('获取用户信息失败，请重新登录！');
        }
      },
      
      // =============================================================================
      // 视角和店铺管理相关方法
      // =============================================================================
      
      // 初始化视角和权限设置
      initializePerspective() {
        // 超级管理员可以管理所有店铺，普通用户只能管理有权限的店铺
        if (this.isSuperAdmin) {
          // 超级管理员：显示所有店铺
          this.managedStores = this.storeUsers;
        } else {
          // 普通用户：筛选有管理权限或员工权限的店铺
          this.managedStores = this.storeUsers.filter(function(storeUser) {
            return storeUser.isAdmin === 1 || storeUser.isEmployee === 1;
          });
        }
        
        // 判断是否显示视角切换器
        // 超级管理员或有管理/员工权限的用户可以看到视角切换器
        this.showPerspectiveSwitcher = this.isSuperAdmin || this.storeUsers.some(function(store) {
          return store.isAdmin === 1 || store.isEmployee === 1;
        });
        
        // 设置默认视角
        // 超级管理员或有管理/员工权限的用户默认进入店铺管理视角
        if ((this.isSuperAdmin || this.hasAdminRole || this.storeUsers.some(su => su.isEmployee === 1)) && !localStorage.getItem('currentPerspective')) {
          this.currentPerspective = 'seller';
          localStorage.setItem('currentPerspective', 'seller');
        }
        
        // 初始化当前店铺
        this.initializeCurrentStore();
      },
      
      // 初始化当前店铺
      initializeCurrentStore() {
        if (this.managedStores.length === 0) return;
        
        const savedStoreId = localStorage.getItem('storeId');
        let targetStore = null;
        
        if (savedStoreId) {
          targetStore = this.managedStores.find(function(store) {
            return store.storeId == savedStoreId;
          });
        }
        
        // 如果没找到保存的店铺，使用第一个管理的店铺
        if (!targetStore) {
          targetStore = this.managedStores[0];
        }
        
        if (targetStore) {
          this.setCurrentStore(targetStore);
        }
      },
      
      // 切换视角
      switchPerspective(perspective) {
        this.currentPerspective = perspective;
        localStorage.setItem('currentPerspective', perspective);
      },
      
      // 设置当前店铺
      setCurrentStore(storeUser) {
        this.currentStoreId = storeUser.storeId;
        this.currentStore = storeUser.store || {};
        this.storeId = storeUser.storeId;
        
        // 更新店铺详细信息
        this.updateStoreInfo(storeUser.store);
        
        // 更新localStorage
        this.updateCurrentStoreId();
      },
      
      // 切换店铺
      async switchStore(storeUser) {
        this.setCurrentStore(storeUser);
        this.showStoreList = false;
        
        try {
          // 获取新店铺的storeUser信息
          const storeUserData = await storeUserApi.getCurrentStoreUser();
          console.log('切换店铺后获取的storeUser:', storeUserData);
          
          // 更新到Vuex store
          this.$store.commit('SET_STORE_USER', storeUserData);
          
          this.$toast('已切换到 ' + storeUser.store.storeName);
        } catch (error) {
          console.error('切换店铺后获取storeUser失败:', error);
          this.$toast('店铺切换成功,但获取权限失败');
        }
      },
      
      // 更新店铺信息
      updateStoreInfo(storeInfo) {
        if (storeInfo && typeof storeInfo === 'object') {
          this.store = Object.assign({}, storeInfo);
        }
      },
      
      // 更新当前店铺ID到localStorage
      updateCurrentStoreId() {
        localStorage.setItem('storeId', this.storeId.toString());
        localStorage.setItem('currentStoreId', this.storeId.toString());
      },
      
      // =============================================================================
      // 显示信息相关方法
      // =============================================================================
      
      // 获取用户头像
      getUserAvatar() {
        if (this.currentPerspective === 'buyer' && this.userProfile && this.userProfile.avatar) {
          return this.userProfile.avatar;
        } else if (this.currentPerspective === 'seller' && this.store && this.store.logo) {
          return this.store.logo;
        }
        return require('@/assets/img/my/null.png');
      },
      
      // 获取用户显示名称
      getUserDisplayName() {
        if (this.currentPerspective === 'buyer') {
          if (this.userProfile && this.userProfile.nickname) {
            return this.userProfile.nickname;
          } else if (this.userProfile && this.userProfile.userName) {
            return this.userProfile.userName;
          } else {
            return this.userProfile.phone;
          }
        } else {
          return (this.store && this.store.storeName) || '暂无';
        }
      },
      
      // 获取当前店铺角色
      getCurrentStoreRole() {
        const self = this;
        const currentStoreUser = this.storeUsers.find(function(su) {
          return su.storeId === self.currentStoreId;
        });
        return this.getStoreRole(currentStoreUser);
      },
      
      // 获取店铺角色文本
      getStoreRole(storeUser) {
        // 超级管理员在所有店铺中都显示为超级管理员
        if (this.isSuperAdmin) return '超级管理员';
        
        if (!storeUser) return '普通用户';
        
        if (storeUser.isAdmin === 1) return '管理员';
        if (storeUser.isAgent === 1) return '代理';
        if (storeUser.isEmployee === 1) return '店员';
        return '普通用户';
      },
      
      // 获取用户角色文本
      getUserRoleText() {
        const roles = [];
        if (this.hasAdminRole) roles.push('管理员');
        if (this.hasAgentRole) roles.push('代理');
        
        return roles.length > 0 ? roles.join('+') : '普通用户';
      },
      
      // =============================================================================
      // 导航和菜单相关方法
      // =============================================================================
      
      // 处理菜单点击
      async handleMenuClick(item) {
        // 如果有特殊的action方法，优先执行
        if (item.action) {
          if (typeof this[item.action] === 'function') {
            this[item.action]();
          }
          return;
        }
        
        // 执行导航前的钩子
        if (item.beforeNavigate) {
          item.beforeNavigate.call(this);
        }
        
        // 处理查询参数
        let query = {};
        if (item.query) {
          query = item.query.call(this);
        }
        
        // 导航到目标页面
        this.$router.push({
          path: item.path,
          query: query
        });
      },
      
      // 跳转到用户/店铺信息页
      jumpUser() {
        const path = this.currentPerspective === 'buyer' ? '/accountInfo' : '/profile/store/info';
        this.$router.push({ path });
      },
      
      // 跳转到名片页
      jumpSliding() {
        this.$router.replace({ path: '/profile/business-card' });
      },
      
      // =============================================================================
      // 功能相关方法
      // =============================================================================
      
      // 退出登录
      logout() {
        this.$dialog.confirm({
          title: '确认退出',
          message: '确定要退出登录吗？',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          clearSession();
          this.$router.replace({ path: '/login' });
          this.$toast('已退出登录');
        }).catch(() => {
          // 用户取消
        });
      },
      
      // 商品管理
      jumpExhibition() {
        this.updateCurrentStoreId();
        this.$router.push({ path: '/Exhibition' });
      },
      
      // 分类管理
      jumpShelfManager() {
        this.updateCurrentStoreId();
        this.$router.push({
          path: '/product/list',
          query: { storeId: this.storeId }
        });
      },
      
      // 扫一扫
      jumpScan() {
        this.$router.push({ path: '/scanformy' });
      },
      
      // 补货
      async jumpSupplement() {
        const permissionObj = this.permissionsList.find(function(item) {
          return item.powerName === '补货';
        });
        if (!permissionObj) {
          this.$toast('权限配置错误');
          return;
        }
        
        await this.getUserWhetherPurchaseStorePermissions(permissionObj.id);
        
        if (this.powerStatus === false) {
          this.$toast('您暂无此权限,请先购买权限配置！');
          this.$router.push({ path: '/buyservice' });
        } else if (this.powerStatus === true) {
          this.$router.push({ path: '/Supplement' });
        }
      },
      
      // 查询用户是否购买功能权限
      async getUserWhetherPurchaseStorePermissions(powerId) {
        try {
          const params = { storeId: this.storeId, powersId: powerId };
          const response = await aGet(api.getUserWhetherPurchaseStorePermissions, params);
          this.powerStatus = response.data;
        } catch (error) {
          console.error('查询权限失败：', error);
          this.powerStatus = false;
        }
      },
      
      // 检查扫码错误消息
      checkScanError() {
        const errorMessage = localStorage.getItem('scanErrorMessage');
        if (errorMessage) {
          this.$dialog.alert({
            title: '商品未找到',
            message: errorMessage,
            confirmButtonText: '确定'
          });
          localStorage.removeItem('scanErrorMessage');
        }
      },
      
      // =============================================================================
      // 兼容方法（保持不变）
      // =============================================================================
      
      // Vuex actions (Vue2兼容写法)
      setStoreId: mapActions(['setStoreId']).setStoreId,
    },
    
    // =============================================================================
    // 生命周期钩子
    // =============================================================================
    
    async created() {
      // 初始化所有数据
      await this.initializeData();
      
      // 设置底部导航栏
      this.$store.state.bmTab = 5;
      
      // NFC相关初始化
      nfc.listenNFCStatus();
      nfc.readData();
    },
    
    mounted() {
      this.checkScanError();
    },
    
    activated() {
      this.checkScanError();
    },
    
    watch: {
      $route(to, from) {
        console.log('路由变化：', to.meta.keepAlive, to);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/mixin';

  .page-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh; /* 确保容器至少占满整个视口高度 */
  }

  .my {
    display: flex;
    flex-direction: column; /* 垂直排列子元素 */
    flex: 1; /* 占据剩余空间 */

    background: #f2f5f3;
    // min-height: 100%;
    // min-width: 100%;
    // max-height: 100%;
    // height: 90%;
    height: 100vh;
    padding-bottom: 60px;

    .perspective-switcher {
      position: relative;
      z-index: 2;
      padding: 15px 30px;
      
      .switcher-container {
        display: flex;
        background: #ffffff;
        border-radius: 20px;
        padding: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        
        .switcher-item {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px 16px;
          border-radius: 15px;
          cursor: pointer;
          transition: all 0.3s ease;
          
          &.active {
            background: #4a90e2;
            color: white;
            
            .switcher-icon {
              filter: brightness(0) invert(1);
            }
          }
          
          .switcher-icon {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
          
          span {
            font-size: 28px;
            font-weight: 500;
          }
        }
      }
    }

    .store-selector {
      position: relative;
      z-index: 2;
      padding: 0 30px 20px;
      
      .store-selector-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 20px;
        padding: 16px 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        
        .current-store {
          display: flex;
          align-items: center;
          
          .store-logo {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 16px;
          }
          
          .store-info {
            .store-name {
              font-size: 32px;
              font-weight: bold;
              color: #222;
              margin-bottom: 4px;
            }
            
            .store-role {
              font-size: 24px;
              color: #666;
            }
          }
        }
        
        .arrow-icon {
          width: 24px;
          height: 24px;
        }
      }
    }

    .store-list-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
      
      .store-list-content {
        background: white;
        border-radius: 20px;
        width: 80%;
        max-height: 70%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #eee;
          
          h3 {
            margin: 0;
            font-size: 32px;
            font-weight: bold;
          }
          
          .close-btn {
            font-size: 40px;
            cursor: pointer;
            color: #999;
          }
        }
        
        .store-search {
          padding: 12px 20px;
          border-bottom: 1px solid #eee;

          .store-search-input {
            width: 100%;
            height: 40px;
            border: 1px solid #ddd;
            border-radius: 8px;
            padding: 0 12px;
            font-size: 16px;
            outline: none;
          }
        }

        .store-list {
          max-height: 400px;
          overflow-y: auto;
          
          .store-item {
            display: flex;
            align-items: center;
            padding: 20px;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            
            &:hover {
              background: #f9f9f9;
            }
            
            &.active {
              background: #e8f4fd;
            }
            
            .store-logo {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              margin-right: 16px;
            }
            
            .store-info {
              flex: 1;
              
              .store-name {
                font-size: 30px;
                font-weight: bold;
                color: #222;
                margin-bottom: 4px;
              }
              
              .store-role {
                font-size: 24px;
                color: #666;
              }
            }
            
            .check-icon {
              width: 24px;
              height: 24px;
            }
          }
        }
      }
    }

    .home-wrapper {
      width: 100%;
      height: 25%;
      background: url('../../assets/img/home/bc.png') center bottom no-repeat;
      background-size: cover;
      position: fixed;
      top: 50px;
      left: 0;
    }

    .user {
      position: relative;
      z-index: 1;
      display: inline-flex;
      width: 100%;
      justify-content: space-between;
      padding: 30px;
      padding-bottom: 0;

      .left {
        display: inline-flex;
        align-items: center;
        flex-wrap: wrap;

        .user-logo {
          width: 40px;
          height: 40px;
        }

        .user-text {
          font-size: 34px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #000000;
          opacity: 1;
          margin-left: 16px;
          margin-right: 20px;
        }

        .store-info-container {
          display: inline-flex;
          align-items: center;
          margin-left: 10px;

          .store-tag {
            padding: 4px 12px;
            background: #4a90e2;
            color: white;
            border-radius: 15px;
            font-size: 24px;
            margin-right: 15px;
          }

          .info-item {
            font-size: 22px;
            color: #666;
            margin-right: 10px;
            white-space: nowrap;

            &:not(:last-child):after {
              content: '|';
              margin-left: 10px;
              color: #ddd;
            }
          }
        }
      }

      .right {
        display: inline-flex;
        align-items: center;

        .user-logo {
          width: 40px;
          height: 40px;
        }

        .user-text {
          // width: 68px;
          // height: 34px;
          // height: 28px;
          line-height: 45px;
          font-size: 28px;
          font-family: Source Han Sans CN;
          opacity: 1;
          margin-left: 16px;
          margin-top: 0px;
        }
      }
    }

    .user-msg {
      padding: 0 32px;
      width: 686px;
      height: 160px;
      background: #ffffff;
      opacity: 1;
      border-radius: 20px;
      position: relative;
      z-index: 1;
      margin-top: 20px;
      margin-left: 32px;
      display: inline-flex;
      justify-content: space-between;

      .left {
        display: inline-flex;
        // padding-right: 40px;
      }

      .user-img {
        width: 96px;
        height: 96px;
        margin-top: 32px;
        border-radius: 50%;
      }

      .user-content {
        margin-left: 32px;
        margin-top: 38px;

        .user-name {
          display: inline-block;
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 51px;
          color: #222222;
          white-space: nowrap; /* 禁止换行 */
          overflow: hidden; /* 超出部分隐藏 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
        }

        .user-reputation {
          .level {
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #222222;
          }
        }
      }

      .user-card {
        width: 150px;
        height: 72px;
        background: #f2f5f3;
        opacity: 1;
        border-radius: 36px;
        display: inline-flex;
        margin-top: 37px;
        // margin-left: 140px;
        justify-content: center;
        align-items: center;

        .card-img {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
      }

      .logout-btn {
        width: 120px;
        height: 72px;
        background: #ff4757;
        opacity: 1;
        border-radius: 36px;
        display: inline-flex;
        margin-top: 37px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: white;

        .logout-icon {
          width: 24px;
          height: 24px;
          margin-right: 8px;
          filter: brightness(0) invert(1);
        }
      }
    }

    .content-box {
      // margin-top: 38%;
      // height: 70%;
      // position: absolute;
      // bottom: 70px;
      // padding-bottom: 150px;
      //margin-top: auto; /* 将上边距设为自动，推到页面底部 */
      //margin-bottom: 20px; /* 可以根据需要调整距离 */

      padding: 20rpx;
      display: flex;
      flex-direction: column;
      justify-content: flex-end; /* 将内容推向父容器底部，靠近 user-foot */
      flex-grow: 1; /* 让 content-box 在剩余空间中自适应大小 */
      margin-bottom: 20px; /* 保持 content-box 与 user-foot 的距离 */
      margin-top: 30px; /* 买家视角下与TAB的间距 */
    }

    .user-body {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      // margin-left: 37px;
      // width: 686px;
      margin: 0 30px;
      height: auto;
      background: #ffffff;
      opacity: 1;
      border-radius: 20px;
      position: relative;
      z-index: 1;


      .box {
        // display: inline-flex;
        // width: 100%;
        // justify-content: left;
        display: flex;
        justify-content: space-between;
        margin: 0 30px;

        .box-content {
          // width: 172px;
          // height: 172px;
          width: 160px;
          height: 140px;
          opacity: 1;
          display: flex;
          // justify-content: center;
          align-items: center;
          flex-direction: column;
          margin-top: 24px;

          .box-img {
            width: 60px;
            height: 60px;
          }

          .box-text {
            margin-top: 16px;
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #222222;
          }
        }
      }
    }

    .store-selector {
      width: 686px;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 20px;
      background: #ffffff;
      border-radius: 20px;
      padding: 20px;
      cursor: pointer;

      .store-selector-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .current-store {
          display: flex;
          align-items: center;
          flex: 1;

          .store-logo {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 20px;
          }

          .store-info {
            flex: 1;

            .store-name {
              font-size: 32px;
              font-weight: bold;
              color: #222222;
              margin-bottom: 8px;
            }

            .store-role {
              font-size: 28px;
              color: #666666;
            }
          }

          .arrow-down {
            font-size: 24px;
            color: #999999;
            margin-left: 20px;
          }
        }
      }
    }

    .user-foot {
      width: 686px;
      height: 163px;
      background: #fff;


      margin: 0 auto; /* 水平居中 */
      margin-top: auto; /* 将上边距设为自动，推到页面底部 */
      margin-bottom: 50px; /* 保持与 tFooter 的距离 */

      display: flex;
      border-radius: 20px;

      .content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .content-img {
          width: 54px;
          height: 54px;
        }

        .content-text {
          font-size: 32px;
          font-family: Source Han Sans CN;
          font-weight: 600;
          margin-top: 15px;
          color: #222222;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/Profile.vue